import { cn } from "tools/ui";

const stylePanel =
  "bg-neutral-200 px-2 custom-transition duration-500 md:sticky md:w-1/3";

function PanelRight({ children, title, displayOpen, style }) {
  const headerStyle = displayOpen ? "pt-5 space-y-3 w-full" : "";

  return (
    <aside id="panel-right" className={stylePanel}>
      <div className={cn("px-3 py-3", headerStyle)}>
        <h3 className="truncate font-medium mt-4 mb-8 text-neutral-600 text-center text-2xl xl:text-4xl">
          {title}
        </h3>
        {children}
      </div>
    </aside>
  );
}

export default PanelRight;
